import { render } from "./employeeassign.vue?vue&type=template&id=08b05ea6&scoped=true"
import script from "./employeeassign.vue?vue&type=script&lang=js"
export * from "./employeeassign.vue?vue&type=script&lang=js"

import "./employeeassign.vue?vue&type=style&index=0&id=08b05ea6&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b05ea6"]])

export default __exports__